import { getInfoCardData } from '../../data/apis/api';
import { useRestQuery } from '../../data/util';
import { QueryKey } from './config';

export const useInfoCardData = (transpilerId: string, isBulk?: boolean) => {
  const data = useRestQuery([QueryKey, 'InfoCardData', transpilerId], () => getInfoCardData(transpilerId, isBulk), {
    retry: false,
    enabled: !!transpilerId,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    sentryTag: 'transpiler.getInfoCardData'
  });

  return data;
};
